module.exports = __webpack_public_path__ + "static/media/badgeAndroid@3x.5770964a.png";